import { render } from "./GridTabParteneri.vue?vue&type=template&id=57ff4742&scoped=true&ts=true"
import script from "./GridTabParteneri.vue?vue&type=script&lang=ts"
export * from "./GridTabParteneri.vue?vue&type=script&lang=ts"

import "./GridTabParteneri.vue?vue&type=style&index=0&id=57ff4742&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ff4742"]])

export default __exports__